// frontend/src/components/FavoritesTab.jsx
import GameCard from './GameCard';
import { colors, fontFamily } from '../theme';

export default function FavoritesTab({ favoriteGames, favoriteTeams, betSlip, onAddToBetSlip, onLoadProps, onToggleFavorite }) {
  return (
    <div className="px-3 pb-24 flex flex-col gap-3 mt-2" style={{ fontFamily }}>
      {favoriteTeams.length === 0 ? (
        <div className="text-center py-16 text-sm" style={{ color: colors.textFaint }}>
          Star a team from any game card to see their upcoming games here.
        </div>
      ) : favoriteGames.length === 0 ? (
        <div className="text-center py-16 text-sm" style={{ color: colors.textFaint }}>
          No upcoming games for your favorite teams right now.
        </div>
      ) : (
        favoriteGames.map(game => (
          <GameCard
            key={game.id}
            game={game}
            onAddToBetSlip={onAddToBetSlip}
            onLoadProps={onLoadProps}
            betSlip={betSlip}
            favoriteTeams={favoriteTeams}
            onToggleFavorite={onToggleFavorite}
          />
        ))
      )}
    </div>
  );
}
